// `?next=`: where to go after signing in.

export const HOME = "/me";

/**
 * Kept only when it is a path on this site: it must start with one "/" (not
 * "//host" or "/\host", which browsers read as another site).
 */
export function safeNext(value: unknown): string | undefined {
  if (typeof value !== "string" || !value.startsWith("/")) return undefined;
  if (value.startsWith("//") || value.startsWith("/\\")) return undefined;
  return value;
}

export const parseNextSearch = (search: Record<string, unknown>) => {
  const next = safeNext(search.next);
  return next ? { next } : {};
};
